export default {
  sections: [],
  term: '',
  termLabel: '',
  sectionCount: 0,
  slideCount: 0,
  filters: {
    name: '',
    sections: [],
    sectionStatus: [],
    sectionsCompleted: { min: null, max: null },
    slidesCompleted: { min: null, max: null },
    lastUpdate: { min: null, max: null },
    excludeTests: true
  },
  pagination: {
    page: 1,
    itemsPerPage: 10,
    sort: [],
    desc: []
  },
  students: [],
  studentCount: 0,
  advisingSelection: ''
}
